// forgot-password.component.ts
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthenticationService } from "../services/authentincation.service";

@Component({
    selector: "app-forgot-password",
    templateUrl: "./forgot-password.component.html",
    styleUrls: ["./forgot-password.component.scss"],
})
export class ForgotPasswordComponent {
    form: FormGroup;
    submitted = false;
    successMessage = "";
    errorMessage = "";

    constructor(
        private fb: FormBuilder,
        private authenticationService: AuthenticationService,
    ) {
        this.form = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
        });
    }

    submit(): void {
        this.submitted = true;
        this.successMessage = "";
        this.errorMessage = "";

        if (this.form.invalid) {
            return;
        }

        const email = this.form.value.email;

        this.authenticationService.sendForgotPasswordEmail(email).subscribe({
            next: () => {
                this.successMessage =
                    "Dacă adresa există în sistem, veți primi un email cu instrucțiuni de resetare a parolei.";
            },
            error: () => {
                this.errorMessage =
                    "A apărut o eroare la trimiterea cererii. Încercați din nou mai târziu.";
            },
        });
    }
}
